import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
} from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { getToken, removeToken } from 'src/utils/localStorage';
import axios from 'axios';

import { ROUTE_SOURCES } from '../constants/routeSources';

const httpLink = new HttpLink({
  uri: process.env.REACT_APP_GQL_ENDPOINT,
});

const authMiddleware = new ApolloLink((operation, forward) => {
  const token = getToken();

  operation.setContext({
    headers: {
      authorization: token ? `Bearer ${token}` : '',
    },
  });

  return forward(operation);
});

const errorLink = onError(({ graphQLErrors }) => {
  if (graphQLErrors) {
    for (const err of graphQLErrors) {
      if (err.extensions?.code === 'UNAUTHENTICATED') {
        removeToken();
        window.location.href = `/${ROUTE_SOURCES.LOGIN}`;
      }
    }
  }
});

export const apolloClient = new ApolloClient({
  link: ApolloLink.from([errorLink, authMiddleware, httpLink]),
  cache: new InMemoryCache({
    typePolicies: {
      AnalyticsAccount: {
        keyFields: false,
      },
      AnalyticsProperty: {
        keyFields: false,
      },
      GoogleAdsAccount: {
        keyFields: false,
      },
      GoogleAdsSubaccount: {
        keyFields: false,
      },
    },
  }),
});

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});
